<template>
  <v-dialog
    persistent
    max-width="600px"
    v-model="editDialog"
  >
    <v-card>
      <v-card-title class="primary--text pb-4 pr-4">
        <h3>{{ editItem.title }}</h3>
        <v-spacer />
        <v-btn
          color="error"
          @click="openRemove"
        >Elimina</v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form
          lazy-validation
          id="edit"
          ref="edit"
          autocomplete="off"
          v-model="valid"
          @submit.prevent="submit"
        >
          <v-container>
            <!-- <v-row>
							<v-select
								label="Attiva"
								item-text="title"
								item-value="value"
								item-color="accent"
								:items="[{ title: 'No', value: 0 }, { title: 'Si', value: 1 }]"
								v-model="edited.is_active"
							/>
						</v-row> -->
            <!-- <v-row>
							<v-select
								label="Categoria Primaria"
								item-text="title"
								item-value="id"
								item-color="accent"
								:items="[{ id: null, title: 'Nessuna' }, ...categories]"
								v-model="edited.parent_id"
							/>
						</v-row> -->
            <v-row>
              <v-text-field
                label="Titolo"
                :rules="rules.title"
                v-model="edited.title"
              />
            </v-row>
            <v-row>
              <v-textarea
                label="Descrizione"
                v-model="edited.description"
              />
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          type="submit"
          form="edit"
        >
          Salva Modifiche
        </v-btn>
        <v-btn
          color="primary"
          @click.stop="closeEdit"
        >Chiudi</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      persistent
      max-width="500px"
      v-model="removeDialog"
    >
      <v-card>
        <v-card-title class="primary--text pb-4">
          <h3>Eliminare categoria?</h3>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-6">
          <h3>
            Confermando, la categoria <u class="primary--text">{{ edited.title }}</u> e tutte le sotto categorie,
            qualora esistano, verranno eliminate definitivamente dal database.
          </h3>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="remove"
          >Conferma</v-btn>
          <v-btn
            color="primary"
            @click="closeRemove"
          >Annulla</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'CategorieEditForm',

    data() {
      return {
        edited: {},
        valid: false,
        rules: {
          title: [(v) => !!v || 'Campo obbligatorio.']
        },
      }
    },

    props: {
      categories: { type: Array, default: () => [] },
      editDialog: { type: Boolean, default: false },
      editItem: { type: Object, default: () => { } },
      closeEdit: { type: Function, default: () => true },
      removeDialog: { type: Boolean, default: false },
      openRemove: { type: Function, default: () => true },
      closeRemove: { type: Function, default: () => true },
    },

    methods: {
      ...mapActions({
        edit: 'editCategory',
        delete: 'deleteCategory',
      }),

      async submit() {
        if (!this.$refs.edit.validate()) return

        this.edit(this.edited)
          .then(() => {
            this.$refs.edit.reset()
            this.closeEdit()

            // this.addToStack({
            // 	color: 'success',
            // 	message: 'Categoria modificata con successo!.',
            // })
          })
          .catch((e) => {
            // this.addToStack({
            // 	color: 'error',
            // 	message: 'Errore nella modifica della categoria..',
            // })
          })
      },

      async remove() {
        this.delete(this.edited)
          .then(() => {
            this.closeRemove()
            this.closeEdit()

            // this.addToStack({
            // 	color: 'success',
            // 	message: 'Categoria eliminata con successo!.',
            // })
          })
          .catch((e) => {
            // this.addToStack({
            // 	color: 'error',
            // 	message: "Errore nell'elimitazione della categoria..",
            // })
          })
      },
    },

    watch: {
      editItem(payload) {
        Object.assign(this.edited, payload)
      },
    },
  }
</script>
